import React, { useState, useEffect } from "react";

const HeightInput = ({ value, onChange }) => {
  const [feet, setFeet] = useState("");
  const [inches, setInches] = useState("");

  useEffect(() => {
    if (value) {
      // Handle the format "6ft 0in"
      const regex = /(\d+)ft\s*(\d+)in/;
      const match = value.match(regex);
      console.log(match)
      if (match) {
        const [_, extractedFeet, extractedInches] = match;
        setFeet(extractedFeet);
        setInches(extractedInches);
      }
    }
  }, [value]);

  const handleFeetChange = (event) => {
    const newFeet = event.target.value;
    setFeet(newFeet);
    if (newFeet && inches) {
      const height = `${newFeet}ft ${inches}in`;
      onChange({ target: { name: 'height', value: height } });
    }
  };

  const handleInchesChange = (event) => {
    const newInches = event.target.value;
    setInches(newInches);
    if (feet && newInches) {
      const height = `${feet}ft ${newInches}in`;
      onChange({ target: { name: 'height', value: height } });
    }
  };

  // The length of 8 covers 1ft through 8ft
  const feetOptions = Array.from({ length: 8 }, (_, i) => (i + 1).toString());
  // The length of 12 covers 0in through 11in
  const inchesOptions = Array.from({ length: 12 }, (_, i) => i.toString());

  return (
    <div className="height-select-container">
      <label htmlFor="height-feet" className="height">
        Height
      </label>
      <div className="camper-info-row" style={{ display: "flex", gap: "2rem" }}>
        <div style={{marginTop: "1em"}}>
          <label htmlFor="height-feet" style={{ display: "block"}}>
            Feet
          </label>
          <select
            id="height-feet"
            className="field"
            name="feet"
            onChange={handleFeetChange}
            value={feet}
            aria-label="Feet portion of height"
          >
            <option value="">Select feet</option>
            {feetOptions.map((ft) => (
              <option value={ft} key={ft}>
                {ft}
              </option>
            ))}
          </select>
        </div>
        <div style={{marginTop: "1em"}}>
          <label htmlFor="height-inches" style={{ display: "block" }}>
            Inches
          </label>
          <select
            id="height-inches"
            className="field"
            name="inches"
            onChange={handleInchesChange}
            value={inches}
            aria-label="Inches portion of height"
          >
            <option value="">Select inches</option>
            {inchesOptions.map((inch) => (
              <option value={inch} key={inch}>
                {inch}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default HeightInput;